import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../colorVars';
import style from './ClosePctButton.module.css';

export const ClosePctButton = ({ percent, quantity, clickHandler, margin }) => {

  return (
    <button
      className={style.button}
      onClick={clickHandler}
      style={{ backgroundColor: colors.red, margin, color: colors.lightGrey }}
    >
      {`${percent}%[${quantity}]`}
    </button>
  );
};

ClosePctButton.propTypes = {
  percent: PropTypes.number,
  quantity: PropTypes.number,
  clickHandler: PropTypes.func,
  margin: PropTypes.string,
};
